import { getDb } from '../db';
import type { QuickFire } from '../../core/types';

/**
 * Quick fires are structural, not vocabulary: fixed set, fixed order, present on
 * every surface, and **exempt from learning** (§5.4). There is deliberately no
 * `recordUse` here — nothing may reorder them.
 */
export const quickFireRepo = {
  async all(): Promise<QuickFire[]> {
    const db = await getDb();
    return (await db.getAll('quickFires')).sort((a, b) => a.order - b.order);
  },

  async upsert(quickFire: QuickFire): Promise<void> {
    const db = await getDb();
    await db.put('quickFires', quickFire);
  },

  async setAudioKey(id: string, audioKey: string): Promise<void> {
    const db = await getDb();
    const tx = db.transaction('quickFires', 'readwrite');
    const existing = await tx.store.get(id);
    if (existing) await tx.store.put({ ...existing, audioKey });
    await tx.done;
  },
};
